   if (!customElements.get('tabbed-content')) {
        class Tabs extends HTMLElement {
          constructor() {
            super();
            this.tabList = this.querySelector('[role="tablist"]');
            this.activeTab = this.tabList.querySelector('[aria-selected="true"]');
            this.isVerticalTablist = this.tabList.getAttribute('aria-orientation') === 'vertical';
            this.tabs = this.querySelectorAll('[role="tab"]');
            this.panels = this.querySelectorAll('[role="tabpanel"]');
      
            // If no tab is active by default, activate the first tab.
            if (!this.activeTab) {
              this.activeTab = this.tabs[0];
              this.activateTab(this.activeTab);
            }
      
            this.addListeners();
          }
      
          addListeners() {
            this.tabList.addEventListener('click', this.handleClick.bind(this));
            this.tabList.addEventListener('keydown', this.handleKeydown.bind(this));
          }
      
          handleClick(evt) {
            if (!evt.target.matches('[role="tab"]') || evt.target === this.activeTab) return;
            this.activateTab(evt.target);
      
          }
      
          handleKeydown(evt) {
            switch (evt.key) {
              case 'ArrowLeft':
              case 'ArrowRight':
                evt.preventDefault();
                if (!this.isVerticalTablist) {
                  this.switchTabOnKeyPress(evt.key);
                }
                break;
      
              case 'ArrowUp':
              case 'ArrowDown':
                evt.preventDefault();
                if (this.isVerticalTablist) {
                  this.switchTabOnKeyPress(evt.key);
                }
                break;
      
              case 'Home':
                evt.preventDefault();
                this.activateTab(this.tabs[0]);
                break;
      
              case 'End':
                evt.preventDefault();
                this.activateTab(this.tabs[this.tabs.length - 1]);
                break;
            }
          }
      
          switchTabOnKeyPress(key) {
            if (key === 'ArrowRight' || key === 'ArrowDown') {
              if (this.activeTab === this.tabs[this.tabs.length - 1]) {
                this.activateTab(this.tabs[0]);
              } else {
                this.activateTab(this.activeTab.nextElementSibling);
              }
            } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
              if (this.activeTab === this.tabs[0]) {
                this.activateTab(this.tabs[this.tabs.length - 1]);
              } else {
                this.activateTab(this.activeTab.previousElementSibling);
              }
            }
          }
      
          activateTab(tab) {
            this.deactivateActiveTab();
      
            Tabs.setTabState(tab, true);
            tab.removeAttribute('tabindex');
            this.activeTab = tab;
      
            const panelId = tab.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);
      
            if (panel) {
              panel.classList.add('fade-in');  // Add animation class
      
              setTimeout(() => {
                panel.classList.remove('fade-in');
              }, 500);
            }
      
            if (document.activeElement.matches('.tablist__tab')) {
              tab.focus();
            }
          }
      
          deactivateActiveTab() {
            Tabs.setTabState(this.activeTab, false);
            this.activeTab.setAttribute('tabindex', '-1');
            this.activeTab = null;
          }
      
          static setTabState(tab, active) {
            tab.setAttribute('aria-selected', active);
      
            const panelId = tab.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);
      
            if (panel) {
              if (active) {
                panel.hidden = false;
              } else {
                panel.hidden = true;
              }
            }
          }
      
        }
      
        customElements.define('tabbed-content', Tabs);
      }